import { render, staticRenderFns } from "./SolarSystemScaleViz.vue?vue&type=template&id=1f40d252&scoped=true"
import script from "./SolarSystemScaleViz.vue?vue&type=script&lang=js"
export * from "./SolarSystemScaleViz.vue?vue&type=script&lang=js"
import style0 from "./SolarSystemScaleViz.vue?vue&type=style&index=0&id=1f40d252&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f40d252",
  null
  
)

export default component.exports